import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';
import am4themes_animated from '@amcharts/amcharts4/themes/animated';

if ($('#diagram').length) {
	am4core.useTheme(am4themes_animated);

	let chart = am4core.create('diagram', am4charts.PieChart3D);

	chart.hiddenState.properties.opacity = 0; // this creates initial fade-in

	chart.legend = new am4charts.Legend();

	if (innerWidth > 1024) {
		chart.legend.position = 'right';
	} else {
		chart.legend.position = 'bottom';
		chart.paddingBottom = 30;
	}

	chart.legend.maxWidth = undefined;
	chart.legend.itemContainers.template.clickable = false;

	chart.data = [
		{
			company: 'Digital Health',
			precent: 16,
		},
		{
			company: 'Mobility',
			precent: 15,
		},
		{
			company: 'Enterprise Software',
			precent: 13,
		},
		{
			company: 'FinTech',
			precent: 12,
		},
		{
			company: 'Travel',
			precent: 10,
		},
		{
			company: 'Consumer Goods',
			precent: 8,
		},
		{
			company: 'AdTech',
			precent: 8,
		},
		{
			company: 'Other',
			precent: 8,
		},
		{
			company: 'PropTech',
			precent: 5,
		},
		{
			company: 'EdTech',
			precent: 5,
		},
	];

	let series = chart.series.push(new am4charts.PieSeries3D());

	series.dataFields.value = 'precent';
	series.dataFields.category = 'company';
	series.labels.template.disabled = true;
	series.ticks.template.disabled = true;
	series.dataFields.value = 'precent';
	series.dataFields.company = 'company';
	series.slices.template.tooltipText = '{company}: {value}%';
	series.colors.list = [
		new am4core.color('#2EC7F2'),
		new am4core.color('#79DBF7'),
		new am4core.color('#9BE4F9'),
		new am4core.color('#BCEDFB'),
		new am4core.color('#CDF2FC'),
		new am4core.color('#DEF6FD'),
		new am4core.color('#DEF6FD'),
		new am4core.color('#DEF6FD'),
		new am4core.color('#EEFBFE'),
		new am4core.color('#EEFBFE'),
	];

	let slice = series.slices.template;

	slice.states.getKey('active').properties.shiftRadius = 0;
}
